export default "__VITE_ASSET__Cbqp3oZv__"